import * as React from "react";
const SvgFiRrFaceLying = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-lying_svg__a)">
      <path
        fill="#062147"
        d="M21.123 18.229a1 1 0 0 1 .134 1.408A11.97 11.97 0 0 1 12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c4.531 0 8.627 2.508 10.691 6.545a1.001 1.001 0 0 1-1.782.91A9.97 9.97 0 0 0 11.999 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.97 9.97 0 0 0 7.715-3.637 1.003 1.003 0 0 1 1.408-.134M21 10h-6a1 1 0 1 0 0 2h6a1.001 1.001 0 0 1 0 2h-6a1 1 0 1 0 0 2h6c1.654 0 3-1.346 3-3s-1.346-3-3-3M6.259 17.67a.997.997 0 0 0 1.412.071c.016-.014 1.587-1.413 3.506-1.757a1.001 1.001 0 0 0-.353-1.969c-2.497.448-4.416 2.171-4.496 2.244a1 1 0 0 0-.068 1.41zM14 7.5a1.5 1.5 0 1 0 3.001-.001A1.5 1.5 0 0 0 14 7.5m-4 0a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 10 7.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-lying_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceLying;
